import { Keys } from '../types';

const keys: Keys = {
  graph: 'a84caa9e5c322a2faec24ad89ccb9d28',
};

export default keys;
